// src/main.tsx
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Toaster } from "./components/ui/sonner";
import { SessionProvider } from "./components/SessionProvider";
// If you want to fetch extra fields from Firestore/API:
import { getFirestore, doc, getDoc } from "firebase/firestore";
import app, { auth } from "./firebase/firebase"; // <-- your single source of truth
import "./index.css";

// Log the timestamp of the last git commit (configurable via VITE_LAST_COMMIT_TS)
const LAST_COMMIT_TIMESTAMP = (import.meta as any)?.env?.VITE_LAST_COMMIT_TS || "2026-01-22 15:49:57 +0100";
console.log("[Build] Last commit timestamp:", LAST_COMMIT_TIMESTAMP);

// Import debug utilities in development
if (import.meta.env.DEV) {
  import("./firebase/debug");
}
async function resolveProfile(uid: string) {
  // Example Firestore loader (adapt collection/path to your schema)
  try {
    const db = getFirestore(app);
    const snap = await getDoc(doc(db, "users", uid));
    if (snap.exists()) {
      const data = snap.data();
      // Make sure you only return serializable fields
      return {
        role: data.role,
        portals: data.portals ?? [],
        managed_structures: data.managed_structures ?? [],
        other_roles: data.other_roles ?? [],
      };
    }
  } catch {
    // ignore errors; SessionProvider will keep Firebase user only
  }
  return null;
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <SessionProvider auth={auth} resolveProfile={resolveProfile}>
      <App />
      <Toaster position="top-center" richColors />
    </SessionProvider>
  </React.StrictMode>
);
